import { render, staticRenderFns } from "./AddBranchComponent.vue?vue&type=template&id=633607dc&"
import script from "./AddBranchComponent.vue?vue&type=script&lang=js&"
export * from "./AddBranchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports